import React, { Component } from 'react';
import {connect} from "react-redux";
import SweetAlert from 'sweetalert-react';
import {showQuestionDialog} from "../../actions/QuestionDialogAction";
import 'sweetalert/dist/sweetalert.css';

class QuestionDialogRx extends Component {
    constructor(props) {
        super(props);
        this.state ={
            question_dialog: props.question_dialog
        }
    }

    componentWillReceiveProps = (nextProps) => {
        if (nextProps.question_dialog ) {
            this.setState({question_dialog: nextProps.question_dialog})
        }
    };

    closeModal = () =>{
        this.props.showQuestionDialog({ confirm: false });
        this.setState({
            question_dialog: {
                show: false,
                text: '',
                confirm_button_text: ''
            }
        });
    }

    handleConfirm = () =>{
        this.props.showQuestionDialog({ confirm: true });
        this.closeModal()
    }

    render() {
        return (
            <SweetAlert
                show={this.state.question_dialog.show}
                title="¿Te gustaría?"
                text={this.state.question_dialog.text}
                type='warning'
                confirmButtonText={this.state.question_dialog.confirm_button_text}
                cancelButtonText="No"
                showCancelButton
                btnSize="xs"
                confirmButtonColor='#e44745'
                onConfirm={() => {
                    this.handleConfirm();
                }}
                onCancel={() => {
                    this.closeModal();
                }}
            />
        );
    }
}

function mapStateToProps(state) {
    return {
        question_dialog: state.get('question_dialog'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        showQuestionDialog(alert) {
            dispatch(showQuestionDialog(alert));
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(QuestionDialogRx);


// WEBPACK FOOTER //
// ./src/components/extras/QuestionDialogRx.js